import React, { PropsWithChildren } from 'react';

export const ValidationMessage = (props: PropsWithChildren<unknown>) => {
    const { children } = props;

    return <span className="validation-message">{children}</span>;
};
